import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faCog, faEdit } from '@fortawesome/pro-light-svg-icons';
import { faPhone } from '@fortawesome/pro-solid-svg-icons';
import { CreNgModule, SpinnerModule } from 'cre-ng';
import { DialogModule } from 'primeng/dialog';
import { ListboxModule } from 'primeng/listbox';
import { SidebarModule } from 'primeng/sidebar';
import { SplitButtonModule } from 'primeng/splitbutton';
import { ToastModule } from 'primeng/toast';

import { SharedModule } from '@app/shared';
import { WigDailyCommitmentFormModule } from '@app/wig-daily-dynamic-commitment-form/wig-daily-dynamic-commitment-form.module';
import { WigDaily5Module } from '../wig-daily5-form/wig-daily5-form.module';
import { WigSummaryComponent } from './wig-summary.component';
import { WigSummaryService } from './wig-summary.service';

@NgModule({
  declarations: [WigSummaryComponent],
  exports: [WigSummaryComponent],
  imports: [
    CommonModule,
    CreNgModule,
    DialogModule,
    FontAwesomeModule,
    FormsModule,
    ListboxModule,
    SharedModule,
    SidebarModule,
    SpinnerModule,
    SplitButtonModule,
    ToastModule,
    WigDaily5Module,
    WigDailyCommitmentFormModule,
  ],
  providers: [WigSummaryService],
})
export class WigSummaryModule {
  constructor(library: FaIconLibrary) {
    // Font Awesome Icons to consume
    library.addIcons(faCog, faPhone, faEdit);
  }
}
